import { nextTick } from 'vue'
import { obterComNotacaoPonto } from 'src/utils/outro/outro'

const TARGET_KEY = '__focusElTarget__'
const HANDLER_KEY = '__focusElHandler__'

function resolverElementoAlvo (alvo) {
  if (!alvo) {
    return null
  }

  if (typeof alvo.focus === 'function') {
    return alvo
  }

  if (alvo.$el) {
    return alvo.$el
  }

  return alvo
}

function cleanup (el) {
  if (!el) {
    return
  }

  const target = el[TARGET_KEY]
  const handler = el[HANDLER_KEY]

  if (target && handler) {
    target.removeEventListener('keydown', handler)
  }

  delete el[TARGET_KEY]
  delete el[HANDLER_KEY]
}

function bindKeyboardNavigation (el, binding) {
  nextTick(() => {
    if (!binding?.value?.refs) {
      cleanup(el)
      return
    }

    const refs = binding.value.refs
    const subEl = binding.value.subEl || null

    const types = []

    const genValidator = (key, targetEl, shift = false, ctrl = false) => {
      types.push([(e) => e.key === key && e.shiftKey === shift && e.ctrlKey === ctrl, resolverElementoAlvo(targetEl)])
    }

    if (binding.value.left) {
      genValidator('ArrowLeft', binding.value.left instanceof Function ? binding.value.left : obterComNotacaoPonto(refs, binding.value.left))
    }
    if (binding.value.right) {
      genValidator('ArrowRight', binding.value.right instanceof Function ? binding.value.right : obterComNotacaoPonto(refs, binding.value.right))
    }
    if (binding.value.down) {
      genValidator('ArrowDown', binding.value.down instanceof Function ? binding.value.down : obterComNotacaoPonto(refs, binding.value.down))
    }
    if (binding.value.up) {
      genValidator('ArrowUp', binding.value.up instanceof Function ? binding.value.up : obterComNotacaoPonto(refs, binding.value.up))
    }
    if (binding.value.esc) {
      genValidator('Escape', binding.value.esc instanceof Function ? binding.value.esc : obterComNotacaoPonto(refs, binding.value.esc))
    }
    if (binding.value.shiftTab) {
      genValidator('Tab', binding.value.shiftTab instanceof Function ? binding.value.shiftTab : obterComNotacaoPonto(refs, binding.value.shiftTab), true)
    }
    if (binding.value.tab) {
      genValidator('Tab', binding.value.tab instanceof Function ? binding.value.tab : obterComNotacaoPonto(refs, binding.value.tab))
    }

    let targetEl = el

    if (subEl) {
      targetEl = resolverElementoAlvo(obterComNotacaoPonto(refs, subEl))
    }

    if (!targetEl) {
      return
    }

    const keydownHandler = (e) => {
      for (const item in types) {
        const func = types[item][0]
        const toFocus = types[item][1]
        if (func(e)) {
          if (toFocus instanceof Function) {
            toFocus()
            return
          }
          if (e.key === 'Tab') {
            e.preventDefault()
          }
          if (typeof toFocus.select === 'function') {
            toFocus.select()
          }
          if (typeof toFocus.focus === 'function') {
            toFocus.focus()
          }
          return
        }
      }
    }

    cleanup(el)
    el[TARGET_KEY] = targetEl
    el[HANDLER_KEY] = keydownHandler
    targetEl.addEventListener('keydown', keydownHandler)
  })
}

export default {
  mounted (el, binding) {
    bindKeyboardNavigation(el, binding)
  },
  updated (el, binding) {
    bindKeyboardNavigation(el, binding)
  },
  unmounted (el) {
    cleanup(el)
  }
}
